import { useMutation, useQueryClient } from '@tanstack/react-query';

import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { APPLICATION_BASE_PATH } from '../../../middle-office/application/constants/applicationBasePath';
import { deleteDocumentById } from '../../requests/deleteDocumentById';
import { DocumentParams } from '../../types/DocumentParams';

export const useDeleteDocumentById = () => {
  const queryClient = useQueryClient();
  const { constructDelete } = useRequestConstructor();

  const { mutateAsync: deleteDocument, ...rest } = useMutation({
    mutationFn: ({
      documentId,
      documentParams,
    }: {
      documentId: string;
      documentParams: DocumentParams;
    }) =>
      deleteDocumentById(constructDelete, documentId, documentParams).then(
        (response) => response?.data,
      ),
    onSuccess: (_, { documentParams }) => {
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, documentParams.definition],
      });
    },
    onError: () => handleError('Failed to delete document'),
  });

  return { deleteDocument, ...rest };
};
